define('plugin/invoice/model/InvoiceTaxModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Invoice tax model
     *
     * @class InvoiceTaxModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: null,
            name: '',
            ratio: 0,
            amount: 0
        }

    });

});
